import { env } from "@/env";
import { isTestEnvironment } from "@/utils/envUtils";

function getAppUrl(): string {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  const envAppUrl = process.env.VITE_APP_URL ?? process.env.APP_URL;
  if (envAppUrl) {
    return envAppUrl;
  }
  return "http://localhost:3000";
}

function getDomainFromUrl(url: string | undefined): string {
  if (!url) {
    return "";
  }
  const withoutProtocol = url.replace(/^https?:\/\//, "");
  const hostWithPath = withoutProtocol.split("/")[0] ?? "";
  return hostWithPath.replace(/^www\./, "");
}

export const APP_URL = getAppUrl();
export const APP_DOMAIN = getDomainFromUrl(APP_URL);
export const EMAIL_SUPPORT = APP_DOMAIN ? `hi@${APP_DOMAIN}` : "hi@localhost";

export const SITE_NAME = "Пирамида Развития";
export const AUTHOR_NAME = env.VITE_MULTILINGUAL ? "" : "Дарина Копенкова";
export const AUTHOR_INSTAGRAM = "https://instagram.com/darina_kopenkova";
export const AUTHOR_TELEGRAM = "https://t.me/piramidaraz";

// SEO Enhancement Constants
export const THEME_COLOR = "#8B5CF6";
export const APP_VERSION = "1.0.0";
export const APP_LAUNCH_DATE = "2024-01-01";
export const TWITTER_SITE = "@piramidaraz"; // Update with actual handle if different
export const TWITTER_CREATOR = "@darina_kopenkova"; // Update with actual handle if different

// Verification codes for search engines
// Google uses DNS TXT record: google-site-verification=sqpAYoUukI_SzAozaj6ulpdvTE9-Tz6z5soJxoCl9n0
export const YANDEX_VERIFICATION = "993986d7b05d5780";

export const NBSP = isTestEnvironment() ? " " : "\xa0";

export const TRPC_PATH = "/api/trpc";

// Yandex Cloud Function URLs
export const YC_FUNCTION_BASE_URL = "https://functions.yandexcloud.net";
